<template>
    <ul class="menu">
        <layout-menu-item v-for="(item,index) of menuList" :menu="item" :key="index"/>
    </ul>
</template>

<script>
    import LayoutMenuItem from './LayoutMenuItem';

    export default {
        name: "layout-menu",

        computed:{
            menuList(){
                return this.$store.state.menuList;
            }
        },

        components:{
            LayoutMenuItem
        }
    }
</script>

<style scoped lang="less">
    @import "../../../assets/css/style";
    .menu{
        display: block;
        float: left;
        height: inherit;
        &:after{
            .clearBoth()
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/elements/LayoutMenu.vue